export default __webpack_public_path__ + "static/media/DTL.eb2e8c8a.png";